import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  margin-top: 10px;
`;
const PalletsInformation = styled.div`
  display: flex;
  width: 100%;

  @media (max-width: 1020px) {
    flex-direction: column;
  }
  > div {
    display: flex;
    flex: 1;
  }
`;
const Lots = styled.div`
  color: #87cdf1;
  display:block;
`;
const Description = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 15px 0 10px;
  flex: 1;
`;
const PalletsSlider = styled.div`
  width: 200px;
`;
const Des = styled.div`
  h2 {
    color: #930000;
    font-size: 18px;
    font-family: 'latobold';
    cursor: pointer;
  }
  p {
    color: #33333a;
    font-size: 14px;
    margin-bottom: 0;
        line-height: 24px;
  }
  span {
    color: #9c9c9c;
  }
`;
const BidInfo = styled.div`
  display: flex;
  p {
    color: #2525ed;
    border-right: solid 2px #d7d7d7;
    padding: 0 15px;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      color: #9c9c9c;
      border: none;
    }
  }
`;
const MaxBid = styled.div`
  color: #9c9c9c;
  p {
    margin: 0;
    font-size: 18px;
  }
  span {
    color: #000000;
    display: inline-flex;
    align-items: center;
  }
`;
const ActionBox = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 446px;

  h2 {
    color: #930000;
    font-size: 26px;
    font-family: 'latobold';
    margin-bottom: 20px;
  }
  @media (max-width: 1020px) {
    max-width: 100%;
  }
`;
const Box = styled.div`
  border-radius: 13px;
  background-color: #d8d8d833;
  padding: 24px;
  display: flex;
  flex-direction: column;
  grid-gap: 15px;
  :nth-child(2) {
    > div {
      min-width: 159px;
    }
  }
`;
const TimeInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px;
  > div {
    display: grid;
    grid-template-rows: 26px;
    
  }
 > div:nth-child(2) {
      min-width: 140px;
    }
  h3 {
    font-size: 18px;
    color: #000000;
    font-family: 'latobold';
    display: flex;
    align-items: center;
  }
  p {
    margin: 0;
    display: flex;
    align-items: center;
    grid-gap: 5px;
    font-size: 14px;
    font-family: 'latoregular';
    margin-top: 5px;
  }
`;
const Action = styled.div`
  display: flex;
  gap: 18px;
  margin-top: 20px;
  button {
    height: 44px;
    text-transform: uppercase;
    min-width: 172px;
    padding: 0 24px;
  }
`;

const FooterBtn = styled.div`
  display: flex;
  justify-content: center;

`
export {
  Container,
  PalletsInformation,
  Description,
  PalletsSlider,
  Des,
  BidInfo,
  MaxBid,
  ActionBox,
  Box,
  TimeInfo,
  Action,
  Lots,
  FooterBtn,
};
